<template functional>
  <div id="add-new-contact">
    <div
      class="dropdown-link"
      @click="props.toggleExpansion"
      :class="{ 'hide-border': props.showExpansion }"
    >
      Select type of contact
      <span><i class="down"/></span>
    </div>

    <transition name="slide-up">
      <ul class="contact-type-option" v-show="props.showExpansion">
        <li
          @click.prevent="
            props.optionSelected({ addOption: 'client', name: props.term })
          "
          class="client-li"
        >
          <a href="#">Client</a>
        </li>
        <li>
          <a href="#" @click.prevent>Other Contact</a>
          <ul>
            <li>
              <a
                href="#"
                @click.prevent="
                  props.optionSelected({
                    addOption: 'person',
                    name: props.term
                  })
                "
                >Person</a
              >
            </li>
            <li>
              <a
                href="#"
                @click.prevent="
                  props.optionSelected({ addOption: 'event', name: props.term })
                "
                >Event</a
              >
            </li>
            <li>
              <a
                href="#"
                @click.prevent="
                  props.optionSelected({ addOption: 'group', name: props.term })
                "
                >Group</a
              >
            </li>
          </ul>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    term: String, // The search term
    optionSelected: Function, // When an option is selected
    showExpansion: Boolean, // Show expansion
    toggleExpansion: Function // Toggle expansion
  }
};
</script>

<style scoped>
.container #add-new-contact {
  justify-content: left !important;
}
#add-new-contact {
  width: 100%;
  margin: 0;
  text-align: left;
  max-width: 400px;
  justify-content: left !important;
}
.contact-type-option {
  padding: 0;
  margin: 0;
  text-align: left;
  list-style: none;
  border: 1px solid #ccc;
}
.contact-type-option li {
  display: block;
  margin: 5px 0;
  border-bottom: 1px solid #eee;
  padding: 5px 10px 5px;
  font-size: 14px;
}
.contact-type-option li ul li {
  display: block;
  margin: 5px 0;
  border-bottom: 1px solid #eee;
  padding: 0;
  font-size: 13px;
}

.contact-type-option li a {
  color: #333;
  font-weight: bold;
}

.contact-type-option li li a {
  color: #666;
  font-weight: normal;
  display: block;
  padding: 5px 10px 5px;
  cursor: pointer;
}

.contact-type-option li a:hover {
  color: #e56700 !important;
}

.client-li:hover {
  cursor: pointer;
}

.client-li:hover a {
  color: #e56700 !important;
}

.contact-type-option li:last-child {
  border-bottom: none;
}

.dropdown-link span i {
  border: solid #acacac;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}

.dropdown-link span i.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.add-other-contact {
  margin: 7px 0px 7px 22px;
}

.psybooks-video {
  flex-direction: column;
  background-color: #fff;
  border-bottom: 1px solid #ccc;
  padding-top: 5px;
  padding-bottom: 5px;
  align-items: flex-start;
  z-index: 999999 !important;
}

.other-contact-wrapper {
  margin-left: 55px;
}

.other-contact-wrapper .container-radio {
  display: inline-block;
}

.other-contact-wrapper .container-radio:last-of-type {
  padding-right: 0px;
}

.slide-up-enter-active {
  animation: slide-up 0.2s ease-in-out forwards;
}

.slide-up-leave-active {
  animation: slide-down 0.2s ease-in-out forwards;
}

@keyframes slide-up {
  from {
    height: 0;
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slide-down {
  from {
    opacity: 1;
  }
  to {
    height: 0;
    opacity: 0;
  }
}

@media (max-width: 376px) {
  .other-contact-wrapper {
    margin-left: 29px;
  }
  .other-contact-wrapper .container-radio {
    padding-left: 20px;
    padding-right: 15px;
  }
}
</style>
